import React from 'react';
import { AlertCircle } from 'lucide-react';
const BeforeYouBook = () => {
  return <div className="bg-amber-50 border-2 border-amber-300 rounded-lg p-6 mb-8" data-id="element-66">
      <div className="flex items-start mb-4" data-id="element-67">
        <AlertCircle size={24} className="text-amber-600 mr-3 mt-1 flex-shrink-0" data-id="element-68" />
        <h3 className="text-xl font-bold text-amber-900" data-id="element-69">Before You Book</h3>
      </div>
      <ul className="space-y-3 text-gray-800" data-id="element-70">
        <li className="flex items-start" data-id="element-71">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-72">•</span>
          <span data-id="element-73">
            You must be able to drive independently and not require verbal or
            physical intervention from the instructor before your driving test.
          </span>
        </li>
        <li className="flex items-start" data-id="element-74">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-75">•</span>
          <span data-id="element-76">
            We recommend passing a mock test at least one month before your DVSA
            test so we can fix anything that's left — otherwise the test may
            need to be rescheduled.
          </span>
        </li>
        <li className="flex items-start" data-id="element-77">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-78">•</span>
          <span data-id="element-79">
            If you or anyone in your household is unwell, please cancel your
            lesson to avoid spreading illness.
          </span>
        </li>
        <li className="flex items-start" data-id="element-80">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-81">•</span>
          <span data-id="element-82">
            Pupils who arrive with cough/cold symptoms may be asked to end the
            lesson to protect other learners.
          </span>
        </li>
        <li className="flex items-start" data-id="element-83">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-84">•</span>
          <span data-id="element-85">
            Please maintain good personal hygiene so the car remains a pleasant,
            professional learning environment.
          </span>
        </li>
        <li className="flex items-start" data-id="element-86">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-87">•</span>
          <span data-id="element-88">
            48 hours' notice is required for cancellations or rescheduling,
            regardless of whether payment was made in advance or on the day.
            Full details are in our{' '}
            <a href="/cancellation" className="text-burgundy-600 hover:text-burgundy-800 font-medium underline" data-id="element-89">
              Cancellation, Health & Safety Policy
            </a>
            .
          </span>
        </li>
      </ul>
    </div>;
};
export default BeforeYouBook;